var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigReys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.094,
    height: 180.297,
    viewBox: "0 0 150.094 180.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20089",
    "data-name": "Group 20089",
    transform: "translate(-124.801 -110.038)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44463",
    "data-name": "Path 44463",
    d: "M127,112.98c1.079,10.193,3.024,20.378,3.453,30.625",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44464",
    "data-name": "Path 44464",
    d: "M159.651,147.4a19.861,19.861,0,0,1,.729-2.781",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44465",
    "data-name": "Path 44465",
    d: "M164.019,131.005c1.726-6.277,4.333-12.251,6.07-18.505",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44466",
    "data-name": "Path 44466",
    d: "M186.845,166.554c5.832-8.1,13.593-14.787,19.749-22.676",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44467",
    "data-name": "Path 44467",
    d: "M213.781,137.353a59.154,59.154,0,0,0,5.937-5.53",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44468",
    "data-name": "Path 44468",
    d: "M209.352,197.412a52.619,52.619,0,0,0,5.328-1.843",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44469",
    "data-name": "Path 44469",
    d: "M227.139,191.265c8.2-2.889,17.168-5.961,24.78-10.228",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44470",
    "data-name": "Path 44470",
    d: "M222.429,230.176c16.624-.6,33.733,2.3,50.257.466",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44471",
    "data-name": "Path 44471",
    d: "M248.342,283.782c4.348,1.648,9.382,1.619,13.49,3.842m-44.35-18.36c10.121,4.765,20.442,10.572,30.859,14.519",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigReys);
export default __webpack_public_path__ + "static/media/bigReys.2f0dfd6f405044a69d841014fca994b9.svg";
export { ForwardRef as ReactComponent };